<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "stressitomasti-tuloksiin";
    let title = "Stressittömästi tuloksiin";
    let author = "Markus";
    let blogDate = "25.12.2020";
    let titlePic = "riippumatto.jpg";
    let firstPara = "Meillä kaikilla on jokin syy motivaattorina, minkä vuoksi treenaamme - jos ja kun treenaamme. \n" +
        "        Jos haluat näkyviä tuloksia , tai vaikka treenaisit vain omaksi iloksesi tai puolisosi käskystä, kannattaa tämä lukea.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>{firstPara}</p>

            <p>Saatko salitreenistä hyviä tuloksia panostamaasi aikaan ja energiaan suhteutettuna?
                Mietitkö koskaan, miten kehittyisit nopeammin?
                Arveletko kehittyväsi hitaammin kuin muut treenaajat?</p>

            <p>Me olemme hyvin erilaisia ja kehitymme eri tahtiin. Osa kehittyy nopeammin ja osa hitaammin.
                Oletko miettinyt koskaan, miksi näin on? Otan tässä nyt käsittelyyn yhden ratkaisun.</p>

            <p>Negatiivinen elämänasenne, stressaaminen pikkuasioista, valittaminen ja huokailu näkyy ihmisen
                ulkomuodossa.
                Nimittäin keho ei erottele fyysistä stressiä ja henkistä stressiä. Jos henkinen kuorma on suuri, meille
                ei jää
                paukkuja enään fyysiseen kehittymiseen.
                Joten hieman kärjistetysti voin sanoa, että ne jotka kokoavat henkistä stressiä elämäänsä eivät voi
                kehittyä
                fyysisesti. He ovat siis aina huonommassa kunnossa, kuin leppoisat ystävänsä.</p>

            <p>Rentous kantaa pitkälle.</p>

            <p>Onko leppoisat ihmiset stressaavia kavereitaan lahjakkaampia? Vai pysyvätkö he saman harrastuksen parissa
                pidempään?
                Vai onko kuitenkin niin, että stressi estää kehittymisen?</p>

            <p>Salilla rentous kumpuaa myös siitä, että on sinut sen kanssa, millaisessa kunnossa on tällä hetkellä. Me
                olemme
                kaikki matkalla vahvempaan ja terveempään tulevaisuuteen, mutta tämän hetkisestä kunnosta stressaaminen
                ei auta.
                Hyväksy siis itsesi ja tee oman kuntosi mukaisia harjoitteita. Katkera kateus muita kohtaan vain estää
                kehittymisen.
                Leppoisa hyväksyntä kantaa pitkälle.</p>

            <h2>Liiallinen stressi tekee meidät sairaaksi ja estää kehittymisen</h2>
            <p>Leppoisat kaverit eivät stressaa. He nukkuvat yönsä hyvin ja levollisesti. He heräävät aamulla täynnä
                tarmoa ja
                hyvällä tuulella.
                Lounaalla heillä ei ole kiire takaisin töihin sykkimään, vaan he malttavat pureskella kiireettömästi
                ruokansa ja
                nauttivat syömisestä.</p>

            <p>Töissä ja opiskeluissa heillä ei näytä olevan kiirettä, eivätkä he kanna koko maailman taakkaa
                harteillaan ja
                siltikin he ovatkin tehokkaita ja hyviä siinä mitä tekevät.</p>

            <p>Treeneistä ja töistä väsyneenä kotiin tullessaan, he eivät kanna tuskaansa muiden niskaan, vaan he
                osaavat
                levähtää
                silloin, kun sitä tarvitsevat.</p>

            <p>Stressi itsessään ei ole haitallista, mutta pitkittyessään se aiheuttaa meissä oireita niin kehossa kuin
                mielessä.
                Stressi pitäisi saada nollattua päivittäin. Jos emme ehdi palautua vuorokauden sisällä, alkaa stressi
                kuluttamaan
                voimavarojamme liikaa.</p>

            <p>Tunnistatko itsestäsi seuraavia stressistä kertovia oireita:</p>

            <p>Fyysisiä oireita on mm:
                Päänsärky, huimaus, vatsavaivat, flunssakierre ja selkävaivat.

                Psyykkisiä oireita on mm:
                Aggressiot, jännittyneisyys, ärtymys, levottomuus, ahdistuneisuus, päätöksentekoon liittyvät ongelmat,
                uniongelmat,
                masennus ja burnout.

                Stressi nostaa kortisolitasoja, jonka oireista osa on yllä. Lisäksi korkeat kortisolitasot aiheuttavat
                painonnousua,
                sotkevat sokeriaineenvaihdunnan, laskevat libidoa ja johtavat muistiongelmiin.</p>

            <h2>Hanki kesäpossu</h2>
            <p>Miten stressiä voi sitten hallita?
                Tietenkin perusasiat onkin sinulla jo tiedossa. Syö terveellisesti, nuku hyvin, urheile säännöllisesti,
                vietä
                aikaa
                mukavien ihmisten kanssa ja rentoudu.</p>

            <p>Myös eläinten seura rentouttaa. Niinpä kesäpossun hankinta ei välttämättä olekaan ihan hullu ajatus,
                vaikkakin
                koira
                voi olla pidemmän päälle helpompi huollettava eikä aiheuta joulun alla niin suurta surua.</p>

            <h2>Muutamia käytännön vinkkejä</h2>
            <p>Olen itse muuttanut omia tapojani ja opetellut stressin hallintaa. Haluaisin niistä vielä jakaa muutaman
                käytännöllisen vinkin.</p>

            <strong>Työ/opiskelu</strong>

            <p>Työt/opiskelut väsyttävät ja aiheuttavat stressiä vähemmän, jos teemme töitä silloin, kun teemme töitä ja
                levähdämme,
                kun pidämme taukoa. Tämä kuulostaa idiootin ohjeelta, mutta tarkoitan sitä, että kokeilepa tehdä töissä
                töitä 25
                minuutin jaksoissa. Keskity vain yhteen asiaan kerrallaan ja pidä välissä 5 minuutin tauko, jonka aikana
                vastaat
                sähköposteihin, luet viestit ja vaihdat muiden kanssa ajatuksia. Googleta Pomodoro, jos haluat tietää
                tästä
                enemmän.

                Olen itse huomannut, että erityisesti illalla olen aivan erilailla virkku, kun hallitsen päivääni
                keskeytyksettömällä työllä. Teen yhden asian kerrallaan valmiiksi ilman häslinkiä ja säntäilyä joka
                suuntaan ja
                jätän säädöt ja keskeytykset niille varatulle kaistalle.</p>

            <strong>Kylmä</strong>

            <p>Tiedät jo, että avanto tekee hyvää. Kylmä mm. tasaa kortisolitasoja (lue yltä, mitä pahoja vaikutuksia
                voit tällä
                välttää). Lisäksi kylmä vähentää stressiä, vilkastuttaa verenkiertoa, nopeuttaa palautumista, auttaa
                tasapainottamaan sokeriaineenvaihduntaa jne.

                Jos et uskalla ensimmäisenä mennä avantoon, niin voit aloittaa kuitenkin kylmähoidot kotona ottamalla
                kylmiä
                suihkuja.

                Huomaatko tässä vaiheessa, kuinka vatsa kiristyy ja ajatus avannosta suorastaan kylmää? Se on
                stressireaktio.
                Leppoisat kaverit olisivat jo käyneet avannossa. Olisiko sinunkin aika kokeilla?

                Itse teen niin, että käyn lähes joka päivä saunassa (joka muuten alentaa tehokkaasti stressiä) ja käyn
                välissä
                kylmässä suihkussa.
                Aamuisin otan yleensä kylmän suihkun seuraavasti:
                Pesen aluksi lämpimän veden alla kuonat iholta. Sitten saippuoin ja pesen saippuat kylmällä vedellä
                pois. Siinä
                menee minuutista kahteen ja sormet jäätyy jo aika huolella, mutta se on kuitenkin ihan tehtävissä.
                Näin toimien tulet huomaamaan mm. ihossa ja hiuksissa merkittäviä muutoksia parempaan suuntaan.
                Kokeilepa.

                Voit yrittää myös Tabatamaista kylmää suihkua, eli kahdeksan (8) kierrosta 20 sekuntia kylmää vettä ja
                väliin 10
                sekuntia lämmintä vettä. Tämäkin herättää aamulla nätisti.</p>

            <strong>Yhteenveto</strong>

            <p>Kroppa ei erottele tuleeko stressi treeneistä vai muusta kuormasta, jota elämä tuo tullessaan.
                Hallitsemalla
                stressiä
                tehokkaasti säästät kehon voimavaroja rakentaa itseään uudestaan treenien jälkeen aina vahvemmaksi ja
                vahvemmaksi.
                Ilman aktiivista ja tietoista stressinhallintaa, on miltei mahdotonta jättää keholle resursseja toipua
                kovista
                salitreeneistä.

                Huolehdi siis, että saat riittävän pitkät unet joka yö. Jätä työasiat töihin ja katko työpäiväsi
                pienempiin
                osiin.
                Tee vain yksi asia kerrallaan.
                Herätä itsesi aamulla kylmässä suihkussa. Jätä vaikka päivän treenit tekemättä, mikäli työstä tulee
                liikaa
                kuormaa
                tai kun yöunet jäävät liian lyhyeksi. Ota kesäpossu tai koira ja anna eläinten seuran rauhoittaa.

                Muista, että enemmän ei ole parempi, kun puhutaan stressistä. Lyhytkestoinen stressi ei meitä riko,
                mutta jos se
                on
                jatkuvaa, niin me sairastumme vähitellen.

                Mukavaa ja stressitöntä jatkoa!
                <br><br>
                Markus
            </p>
        </article>



        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen hyödyntämiseen' titlePic='2014/etunojapunnerrus2.jpg' blogDate='' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='stressaako' title='Stressaako?' titlePic='stressi.jpg' blogDate='' firstPara='Viime aikoina on puhuttu paljon stressistä ja sen vaikutuksista. Pitkittyneellä stressireaktiolla on yhteys elimistön lievään tulehdustilaan, joka voi johtaa monenlaisiin ongelmiin.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='miten-tehda-treenaamisesta-hauskaa' title='Miten tehdä treenaamisesta hauskaa?' titlePic='dynamopaidat.jpg' blogDate='' firstPara='Salilla on kiva käydä ja siitä tulee keskimäärin mukavampaa, jos siellä kehittyy. Eikö vain?'></BlogSummary>
                </article>
            </div>
        </section>

    </div>
{/if}

<style>


</style>